import React from 'react'
import questionImg from '../../images/question.png'

class Header extends React.Component {
  render () {
    return (
        <div className={`liveroom-setting-header ${this.props.className || ''}`}>
            <div className="rect"></div>
            <div className="title">
              {this.props.title}
              { this.props.isQuestion && 
                <div onClick={this.props.onClickQuestion} className="question">
                  <img src={questionImg} alt=""/>  
                </div> 
              }
            </div>
        </div>
    )
  }
}

export default Header


// WEBPACK FOOTER //
// ./src/components/wk/WKGreenTitle.js